import * as React from 'react';
import Select, { Option } from 'react-select';
import 'react-select/dist/react-select.css';

export interface Props {
    label: string;
    options: {label: string; value: number}[];
    initialSelectedOptions: number[];
    onChange: (value: number[]) => void;
    placeholder?: string;
    disabled?: boolean;
}

const FormMultiSelect = (props: Props) => {

    const selectChanged = (newValues: Option[]) => {
        props.onChange(newValues.map(option => {
            // values are mandated as numbers above
            return option.value! as number;
        }));
    };

    return (
        <div className="form-group">
            <label className="font-weight-bold">
                {props.label}
            </label>
            <Select
                closeOnSelect={true}
                disabled={props.disabled || false}
                multi={true}
                onChange={selectChanged}
                options={props.options}
                placeholder={props.placeholder}
                removeSelected={true}
                rtl={false}
                simpleValue={false}
                value={props.initialSelectedOptions}
            />
        </div>
    );
};

export default FormMultiSelect;


// WEBPACK FOOTER //
// ./src/components/common/form/MultiSelect.tsx